import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {NgIf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() public placeholder: string = '';
  @Input() public icon: string = '';
  @Input() public prepend: string = '';
  @Input() public type: string = 'text';
  public control = new FormControl();
  public onChange: (value: string) => void = () => {};
  public onTouched: () => void = () => {};
  private subscriptions: Subscription[] = [];

  constructor() {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.control.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.control.setValue(value);
  }
}
